import { ActionTree } from "vuex";
import { IPagination, RootState } from "@/types";
import { IProgress, ProgressState } from "@/types/progress";
import CustomRequest from "../customRequest";

const actions: ActionTree<ProgressState, RootState> = {
  async flipStatus({ commit }, progress_id: number) {
    const { error } = await CustomRequest.patch<IPagination<IProgress>>({
      uri: `/sales/progress/${progress_id}/flip`,
      commit,
      target: "single",
      flash: true,
    });

    return !error;
  },
};

export default actions;
